var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background-color":"#fdd7c2"}},[_c('first'),_c('second'),_c('third'),_c('fourth'),_c('fifth')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }